var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.overPaid > 0.1)?_c('div',{staticClass:"my-3"},[_c('v-btn',{attrs:{"outlined":"","small":"","color":"secondary","loading":_vm.loading},on:{"click":function($event){return _vm.send()}}},[_vm._v("Alert POS Overpayment")]),_c('span',{staticClass:"mx-2"},[_vm._v(_vm._s(_vm.message))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }